import React from "react";
import { Briefcase, Calendar, MapPin, CheckCircle2, Building2 } from "lucide-react";
import "./Experience.css";

const experiences = [
  {
    role: "Full Stack Developer",
    company: "Graduate Chai & Lassi Pvt Ltd",
    period: "Jun 2025 – Jul 2026",
    type: "Full-Time Software Engineering",
    location: "India",
    overview:
      "Engineered full-stack business software solutions, enterprise ERP platforms, and operational systems for commercial franchises and client networks.",
    achievements: [
      "Developed an ERP software solution for Graduate Udyog Samuh using Node.js and PostgreSQL for inventory, billing, and account management.",
      "Built billing, inventory, and account management systems for Carcuro, including REST API design and database integration.",
      "Customized scalable business software solutions based on client requirements across multiple projects.",
      "Debugged and optimized backend workflows to improve reliability, performance, and automation.",
      "Worked on scalable backend architectures, authentication systems, RESTful APIs, and realtime operational systems.",
    ],
    skills: ["Node.js", "PostgreSQL", "RESTful APIs", "ERP Architecture", "Billing Systems", "Authentication", "Workflow Optimization"],
  },
  {
    role: "Full Stack Developer Intern",
    company: "Cipheren Technology",
    period: "Jul 2024 – Sept 2024",
    type: "Engineering Internship",
    location: "India",
    overview:
      "Developed educational technology systems and centralized administrative dashboards with strict access control.",
    achievements: [
      "Developed an LMS (Learning Management System) platform with an admin dashboard, building frontend and backend independently.",
      "Designed and implemented RESTful APIs and managed database operations.",
      "Implemented JWT-based authentication and role-based access control (RBAC).",
      "Built analytics dashboards and operational tracking systems for educational performance monitoring.",
    ],
    skills: ["React.js", "Node.js", "JWT", "RBAC", "RESTful APIs", "Dashboard Analytics", "Database Management"],
  },
];

const Experience = () => {
  return (
    <section id="experience" className="section section-secondary experience-section">
      <div className="container">
        
        {/* SECTION HEADER */}
        <div className="section-header">
          <div className="eyebrow">03 / Career History</div>
          <h2 className="section-title">
            Engineering <em>Experience</em>
          </h2>
          <p className="section-subtitle">
            Professional track record developing full-stack business software, ERP platforms, and operational systems for real enterprise clients.
          </p>
        </div>

        {/* TIMELINE CONTAINER */}
        <div className="experience-timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="experience-timeline-card">
              
              {/* TIMELINE SIDE COLUMN */}
              <div className="exp-side-col">
                <div className="exp-badge-group">
                  <span className="badge badge-terracotta">{exp.period}</span>
                  <span className="badge badge-neutral">{exp.type}</span>
                </div>
                <div className="exp-company-block">
                  <Building2 size={16} className="exp-icon" />
                  <span className="exp-company-name">{exp.company}</span>
                </div>
              </div>

              {/* TIMELINE MAIN CONTENT */}
              <div className="exp-main-col">
                <h3 className="exp-role-title">{exp.role}</h3>
                <p className="exp-overview">{exp.overview}</p>

                <div className="exp-bullets-header">Key Engineering Contributions:</div>
                <ul className="exp-bullets">
                  {exp.achievements.map((item, idx) => (
                    <li key={idx}>
                      <CheckCircle2 size={15} className="exp-check" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                {/* SKILLS STRIP */}
                <div className="exp-skills-strip">
                  {exp.skills.map((s, sIdx) => (
                    <span key={sIdx} className="exp-skill-tag">{s}</span>
                  ))}
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Experience;